import { LoadingButton } from '@ui';
import React, { useEffect, useState } from 'react';
import { useAlerts } from '../../feedback';
import { useWebshop } from '../webshop';
import { BillingTableItem } from './types';
import { UnappliedCreditsAvailableDialog } from './UnappliedCreditsAvailableDialog';
import { useBillingPayment } from './useBillingPayment';
import { useMetricsQuery } from './useMetricsQuery';

export type PayInvoicesButtonProps = { billingItems: BillingTableItem[] } & React.ComponentProps<
  typeof LoadingButton
>;

export const PayInvoicesButton: React.FC<PayInvoicesButtonProps> = ({ billingItems, ...rest }) => {
  const { status } = useWebshop();
  const payInvoices = useBillingPayment(billingItems);
  const [showDialog, setShowDialog] = useState(false);
  const { unappliedBalance } = useMetricsQuery();
  const { showError } = useAlerts();

  useEffect(() => {
    if (status === 'error') {
      showError('Could not load payment module');
    }
  }, [status, showError]);

  if (status === 'error' || !payInvoices) {
    return null;
  }

  const onClick = () => (unappliedBalance ? setShowDialog(true) : onContinue());
  const onDismiss = () => setShowDialog(false);
  const onContinue = () => {
    setShowDialog(false);
    void payInvoices();
  };

  return (
    <>
      <UnappliedCreditsAvailableDialog
        open={showDialog}
        onContinue={onContinue}
        onClose={onDismiss}
      />
      <LoadingButton
        variant={'outlined'}
        onClick={onClick}
        disabled={status !== 'loaded'}
        loading={status === 'loading'}
        {...rest}
      />
    </>
  );
};
